import { render } from "./EonTabMenu.vue?vue&type=template&id=5a15d3b7&scoped=true"
import script from "./EonTabMenu.vue?vue&type=script&lang=js"
export * from "./EonTabMenu.vue?vue&type=script&lang=js"

import "./EonTabMenu.vue?vue&type=style&index=0&id=5a15d3b7&lang=less"
import "./EonTabMenu.vue?vue&type=style&index=1&id=5a15d3b7&scoped=true&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a15d3b7"]])

export default __exports__